export default __webpack_public_path__ + "static/media/O-104.2eec2f88.png";